import { render, staticRenderFns } from "./MagazineManagement.vue?vue&type=template&id=22026971&scoped=true"
import script from "./MagazineManagement.vue?vue&type=script&lang=js"
export * from "./MagazineManagement.vue?vue&type=script&lang=js"
import style0 from "./MagazineManagement.vue?vue&type=style&index=0&id=22026971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22026971",
  null
  
)

export default component.exports